(function () {
    if (customElements.get('related-products-slider')) return;
  
    class RelatedProductsSlider extends HTMLElement {
      constructor() {
        super();
        this._index = 0;
        this._startX = 0;
        this._currentX = 0;
        this._isDragging = false;
        this._cols = 2;
      }
  
      connectedCallback() {
        if (window.innerWidth >= 750) return;
  
        if (this.querySelector('.rps__track .grid__item')) {
          this._cols = parseInt(this.dataset.columnsMobile) || 2;
          this._init();
          return;
        }
  
        const observer = new MutationObserver(() => {
          if (this.querySelector('.rps__track .grid__item')) {
            observer.disconnect();
            this._cols = parseInt(this.dataset.columnsMobile) || 2;
            this._init();
          }
        });
  
        observer.observe(this, { childList: true, subtree: true });
      }
  
      _init() {
        this._track = this.querySelector('.rps__track');
        this._dotsContainer = this.querySelector('.rps__dots');
        if (!this._track) return;
  
        this._items = Array.from(this._track.querySelectorAll('.grid__item'));
        this._total = this._items.length;
        this._pages = Math.ceil(this._total / this._cols);
  
        this._buildDots();
        this._bindEvents();
        this._goTo(0, false);
      }
  
      _buildDots() {
        this._dotsContainer.innerHTML = '';
        this._dots = [];
        if (this._pages <= 1) return;
  
        for (let i = 0; i < this._pages; i++) {
          const btn = document.createElement('button');
          btn.className = 'rps__dot';
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-label', `Sayfa ${i + 1}`);
          btn.addEventListener('click', () => this._goTo(i));
          this._dotsContainer.appendChild(btn);
          this._dots.push(btn);
        }
      }
  
      _goTo(index, animate = true) {
        this._index = Math.max(0, Math.min(index, this._pages - 1));
  
        const itemWidth = this._items[0]?.offsetWidth || 0;
        const gap = 12;
        const offset = this._index * this._cols * (itemWidth + gap);
  
        this._track.style.transition = animate
          ? 'transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
          : 'none';
        this._track.style.transform = `translateX(-${offset}px)`;
  
        this._dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this._index);
          dot.setAttribute('aria-selected', i === this._index ? 'true' : 'false');
        });
      }
  
      _bindEvents() {
        const track = this._track;
  
        track.addEventListener('touchstart', (e) => this._onDragStart(e.touches[0].clientX), { passive: true });
        track.addEventListener('touchmove', (e) => this._onDragMove(e.touches[0].clientX), { passive: true });
        track.addEventListener('touchend', () => this._onDragEnd());
  
        track.addEventListener('mousedown', (e) => { e.preventDefault(); this._onDragStart(e.clientX); });
        window.addEventListener('mousemove', (e) => { if (this._isDragging) this._onDragMove(e.clientX); });
        window.addEventListener('mouseup', () => { if (this._isDragging) this._onDragEnd(); });
  
        track.addEventListener('click', (e) => {
          if (Math.abs(this._currentX - this._startX) > 5) e.preventDefault();
        }, true);
  
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            if (window.innerWidth >= 750) return;
            this._goTo(this._index, false);
          }, 150);
        });
      }
  
      _onDragStart(x) {
        this._isDragging = true;
        this._startX = x;
        this._currentX = x;
        this._track.classList.add('is-dragging');
      }
  
      _onDragMove(x) {
        if (!this._isDragging) return;
        this._currentX = x;
        const diff = this._startX - x;
        const itemWidth = this._items[0]?.offsetWidth || 0;
        const gap = 12;
        const baseOffset = this._index * this._cols * (itemWidth + gap);
  
        this._track.style.transition = 'none';
        this._track.style.transform = `translateX(-${baseOffset + diff}px)`;
      }
  
      _onDragEnd() {
        if (!this._isDragging) return;
        this._isDragging = false;
        this._track.classList.remove('is-dragging');
  
        const diff = this._startX - this._currentX;
  
        if (diff > 50) {
          this._goTo(this._index + 1);
        } else if (diff < -50) {
          this._goTo(this._index - 1);
        } else {
          this._goTo(this._index);
        }
      }
    }
  
    customElements.define('related-products-slider', RelatedProductsSlider);
  })();